// extracted by mini-css-extract-plugin
export default {"menu":"StaffContextMenu_menu__Ep+Xm","row":"StaffContextMenu_row__aR8iX","rowMuted":"StaffContextMenu_rowMuted__Lz8uH","glyph":"StaffContextMenu_glyph__R8a2k"};